// Centralized pillar configuration shared by client and server
// Source of truth for pillar names and colors

export const PILLAR_NAMES = [
  'Account Reconciliation',
  'Journal Entry Automation',
  'Intercompany',
  'Close Management',
  'Other Processes',
] as const

export type PillarName = typeof PILLAR_NAMES[number]

// Canonical colors for each pillar (single source of truth)
export const PILLAR_COLORS: Record<PillarName, string> = {
  'Account Reconciliation': '#34E5E2', // Teal
  'Journal Entry Automation': '#50A0FF', // Blue
  'Intercompany': '#7A00C1', // Emerald (as per existing comment)
  'Close Management': '#006170', // Indigo
  'Other Processes': '#FF715A', // Orange
}

// Helper: safely get a pillar color with optional fallback
export function getPillarColor(pillar: string, fallback = '#cb046f'): string {
  const match = PILLAR_NAMES.find((name) => name === pillar)
  return (match && PILLAR_COLORS[match]) || fallback
}
